import axios from './api'
const buyServer = {	 
	SearchPayList(params) {
		return axios.post(`app/wallet/sku/listAll`, params).then((res) => {
            return res.data
        })
	},
	SearchPayView(params) {
		return axios.post(`app/cashier/submit`, params).then((res) => {
            return res.data
        })
	},
	SearchPayInfo(params) {
		return axios.post(`app/cashier/flow/get`, params).then((res) => {
            return res.data
        })
	},
	SearchPayID(params) {
		return axios.post(`app/wallet/recharge/create`, params).then((res) => {
            return res.data
        })
	},
	SearchPayType(params) {
		return axios.post(`app/cashier/listByClientType/get`, params).then((res) => {
            return res.data
        })
	},
	SearchProductId(params) {
		return axios.post(`app/cashier/listByClientType/get`, params).then((res) => {
            return res.data
        })
	},

	verificatPay(params) {
		return axios.post(`apple/pay/callBack/public`, params).then((res) => {
            return res.data
        })
	}
	
}

export default buyServer


// WEBPACK FOOTER //
// ./src/api/buy.js